import { useLabelVersion } from '../../../../../features/labels/LabelsProvider';
import { labelRegion, labelArea, labelCentro } from '../../../../../features/labels/labels';
import React, { memo, useMemo, useEffect, useCallback } from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Button,
  Divider,
  Typography,
  Zoom,
} from '@mui/material';
import {
  FmdGood as FmdGoodIcon,
  Public as PublicIcon,
  TravelExplore as TravelExploreIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Logout as LogoutIcon,
  Apps as AppsIcon,
} from '@mui/icons-material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import './DrawerList.css'

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    disablePortal                             // ① renderiza dentro del DOM normal
    PopperProps={{                            // ② modifcadores de Popper
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            boundary: 'scrollParent'         // limita el overflow al scroll parent
          },
        },
        {
          name: 'flip',
          options: {
            boundary: 'scrollParent'
          }
        }
      ],
    }}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
    fontSize: '0.7vw',
    marginBottom: '0.4vh'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgb(0, 0, 0)',
    borderRadius: '0.5vw',
    fontSize: '0.5vw',
    padding: '1vh 1vw',
    maxWidth:'10vw',
    textAlign:'center'
  },
}));

const isSameSelectionValue = (left, right) =>
  String(left ?? '').trim().toLowerCase() === String(right ?? '').trim().toLowerCase();



// Reusable section component
// const Section = ({
//   label,
//   items = [],
//   open,
//   onToggle,
//   disabled,
//   itemIcon,
//   onItemClick,
//   selected,
//   translate,
//   capitalize,
//   sidebarOpen,
//   fontSize,
//   handleNivel
// }) => {
//   const type = label.endsWith('s') ? label.slice(0, -1) : label;
//   // console.log('type',type)

//   const Translatetype = translate(type);
//   console.log('selected',label)


//   return (
//     <Box>
//       <Box display="flex" alignItems="center" px={1} py={0.5}>
//         <Typography sx={{ color: 'white', fontSize }}>{translate(label)}</Typography>
//         <IconButton onClick={onToggle} disabled={disabled} sx={{ color: 'white', ml: 'auto' }}>
//           {open ? <ExpandLessIcon sx={{ fontSize }} /> : <ExpandMoreIcon sx={{ fontSize }} />}
//         </IconButton>
//       </Box>

//       {open && (
//         <List disablePadding style={{}}>
//           {items.map((value, idx) => (
//             <BootstrapTooltip
//               key={idx}
//               title={`Haz clic en el icono para ver los datos de ${Translatetype}`}
//               arrow
//               placement="right"
//               TransitionComponent={Zoom}
//               enterDelay={300}
//             >
//               <ListItemButton
//                 selected={selected === value}
//                 onClick={() => onItemClick(value)}
//                 sx={{
//                   height: '5vh',
//                   width: '12vw',
//                   // border:'solid',
//                   pl: 2,
//                   py: 1,
//                   borderRadius:'0.4vw',
//                   marginLeft:'0.3vw',
//                   marginTop:'0.5vh',
//                   '&.Mui-selected': {
//                     backgroundColor: 'rgb(222, 78, 17)',
//                   },
//                   '&:hover': {
//                     backgroundColor: 'rgb(255,120,60)',
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  
//                     <IconButton
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         console.log(`Accediste a esta ${type}:`, value);
//                         onItemClick(value);
//                         handleNivel(type);
//                       }}
//                       sx={{
//                         color: 'white',
//                         bgcolor: '#303e54',
//                         borderRadius: '0.25vw', p: '0.25vw',
//                         '&:hover': {
//                           bgcolor: 'rgb(222, 78, 17)', // el color de fondo al pasar el ratón
//                         }
//                       }}
//                       size="small"
//                     >
//                       {itemIcon}
//                     </IconButton>
                  
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={capitalize(value)}
//                   primaryTypographyProps={{
//                     noWrap: true,
//                     sx: { opacity: sidebarOpen ? 1 : 0, fontSize: '1.2vh', marginLeft:'0.5vw' },
//                   }}
//                 />
//                 <ListItemIcon sx={{ minWidth: 32, mr: 1 ,}}>
//                   { label==='areas' &&
//                     <IconButton
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         console.log(`Accediste a esta ${type}:`, value);
//                         onItemClick(value);
//                         handleNivel(type);
//                       }}

//                       sx={{
//                         color: 'white',
//                         bgcolor: 'rgba(0, 0, 0, 0)',
//                         borderRadius: '0.25vw', p: '0.25vw',
//                         display: selected === value ? 'flex' : 'none',
//                         '.MuiListItemButton-root:hover &': {
//                           display: 'flex'
//                         },
//                         '&:hover': {
//                           bgcolor: 'rgb(222, 78, 17)', 
//                         }
//                       }}
//                       size="small"
//                     >
//                       <span className="loader"></span>
//                     </IconButton>
//                   }
//                 </ListItemIcon>
//               </ListItemButton>
//             </BootstrapTooltip>
//           ))}
//         </List>
//       )}
//     </Box>
//   );
// };
const Section = memo(({
  label,
  items = [],
  open,
  onToggle,
  collapsible = true,
  disabled,
  itemIcon,
  onItemClick,
  selected,
  translate,
  capitalize,
  sidebarOpen,
  fontSize,
  handleNivel,
  region
}) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === 'function' ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };
  const type = label.endsWith('s') ? label.slice(0, -1) : label;
  const translatedType = t(type, type);
  const sectionLabel = t(label, label);
  const showTooltip = label === 'regions';

  return (
    <Box>
      <Box display="flex" alignItems="center" px={1} py={0.5}>
        <Typography sx={{ color: 'white', fontSize }}>{sectionLabel}</Typography>
        {collapsible && (
          <IconButton onClick={onToggle} disabled={disabled}  sx={{ color: 'white', ml: 'auto' }}>
            {open ? <ExpandLessIcon sx={{ fontSize }} /> : <ExpandMoreIcon sx={{ fontSize }} />}
          </IconButton>
        )}
      </Box>

      {open && (
        <List disablePadding>
          {items.map((value, idx) => {
            const content = (
              <ListItemButton
                key={idx}
                selected={isSameSelectionValue(selected, value)}
                onClick={() => onItemClick(value)}
                sx={{
                  height: '5vh',
                  width: '12vw',
                  pl: 2,
                  py: 1,
                  borderRadius: '0.4vw',
                  marginLeft: '0.3vw',
                  marginTop: '0.5vh',
                  '&.Mui-selected': {
                    backgroundColor: 'rgb(222, 78, 17)',
                  },
                  '&:hover': {
                    backgroundColor: 'rgb(255,120,60)',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <IconButton
                    onClick={e => {
                      if (label !== 'areas') return;
                      e.stopPropagation();
                      onItemClick(value);
                      handleNivel(type);
                    }}
                    sx={{
                      color: 'white',
                      bgcolor: '#303e54',
                      borderRadius: '0.25vw',
                      p: '0.25vw',
                      '&:hover': {
                        bgcolor: 'rgb(222, 78, 17)',
                      },
                    }}
                    size="small"
                  >
                    {itemIcon}
                  </IconButton>
                </ListItemIcon>
                <ListItemText
                  primary={label === "regions" ? labelRegion(value, capitalize(value)) : labelArea({ region, area: value }, capitalize(value))}
                  primaryTypographyProps={{
                    noWrap: true,
                    sx: { opacity: sidebarOpen ? 1 : 0, fontSize: '1.2vh', marginLeft: '0.5vw' },
                  }}
                />
                {/* <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  { label === 'areas' &&
                    <IconButton
                      onClick={e => {
                        e.stopPropagation();
                        onItemClick(value);
                        handleNivel(type);
                      }}
                      sx={{
                        color: 'white',
                        bgcolor: 'rgba(0, 0, 0, 0)',
                        borderRadius: '0.25vw',
                        p: '0.25vw',
                        display: isSameSelectionValue(selected, value) ? 'flex' : 'none',
                        '.MuiListItemButton-root:hover &': {
                          display: 'flex'
                        },
                        '&:hover': {
                          bgcolor: 'rgb(222, 78, 17)',
                        }
                      }}
                      size="small"
                    >
                      <span className="loader"></span>
                    </IconButton>
                  }
                </ListItemIcon> */}
              </ListItemButton>
            );

            return showTooltip ? 
            (
              <BootstrapTooltip
                key={idx}
                title={t('open_data_for', `Haz clic en el icono para ver los datos de ${translatedType}`, { type: translatedType })}
                arrow
                placement="right"
                TransitionComponent={Zoom}
                enterDelay={300}
              >
                {content}
              </BootstrapTooltip>
            ) : (
              content
            );
          })}
        </List>
      )}
    </Box>
  );
});


const DrawerList = ({
  showOptions,
  translate,
  showAreas,
  setShowAreas,
  regionSeleccionada,
  areaSeleccionada,
  centroSeleccionado,
  selectedCenters,
  handleRegionClick,
  handleAreaClick,
  handleCentroClick,
  capitalize,
  permisosCentros,
  nivelSeleccionado,
  handleExit,
  setNivelSeleccionado
}) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === 'function' ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };
// console.log('selectedCenters',selectedCenters)
// console.log('regionSeleccionada',regionSeleccionada)
// console.log('areaSeleccionada',areaSeleccionada)
// console.log('centroSeleccionado',centroSeleccionado)
  const homeLabel = t('home', 'Home');

  useEffect(() => {
    if (!regionSeleccionada) {
      const stored = localStorage.getItem('REGION');
      if (stored) {
        try {
          handleRegionClick(JSON.parse(stored));
        } catch {
          handleRegionClick(stored.replace(/^"|"$/g, ''));
        }
      }
    }
    if (!areaSeleccionada) {
      const stored = localStorage.getItem('AREA');
      if (stored) {
        try {
          handleAreaClick(JSON.parse(stored));
        } catch {
          handleAreaClick(stored.replace(/^"|"$/g, ''));
        }
      }
    }
    if (!centroSeleccionado) {
      const stored = localStorage.getItem('CENTRO');
      if (stored) {
        handleCentroClick(stored.replace(/^"|"$/g, ''));
      }
    }
  }, []);


  // Ensure permisosCentros always has an array
  const centersData = permisosCentros?.centers ?? [];

  // Parse and memoize permissions
  const perms = useMemo(
    () =>
      centersData.map((str) => {
        const [region, area, center] = str.split('-');
        return { region, area, center };
      }),
    [centersData]
  );

  const regions = useMemo(
    () => Array.from(new Set(perms.map((p) => p.region))),
    [perms]
  );
  const areas = useMemo(
    () =>
      regionSeleccionada
        ? Array.from(
            new Set(
              perms
                .filter((p) => isSameSelectionValue(p.region, regionSeleccionada))
                .map((p) => p.area)
            )
          )
        : [],
    [perms, regionSeleccionada]
  );
  const centers = useMemo(
    () =>
      regionSeleccionada && areaSeleccionada
        ? Array.from(
            new Set(
              perms
                .filter(
                  (p) =>
                    isSameSelectionValue(p.region, regionSeleccionada) &&
                    isSameSelectionValue(p.area, areaSeleccionada)
                )
                .map((p) => p.center)
            )
          )
        : [],
    [perms, regionSeleccionada, areaSeleccionada]
  );

const styleFont ='1vw'
    //* ------------------------ Función: handleHome ------------------------------------------------------
  //? Descripción: Redirige a la página de inicio al hacer clic en el menú de usuario.
  const handleHome = useCallback(() => {
      window.location.href = "/home";
  }, []);

  //* ------------------------ Función: handleNivel ------------------------------------------------
  //? Descripción: Maneja el nivel de seleccion en el menu .
  const handleNivel = useCallback((nivel) => {
    setNivelSeleccionado(nivel);
    console.log('Nivel guardado:', nivel);
  }, [setNivelSeleccionado]);

  const publicIcon = useMemo(() => <PublicIcon sx={{ fontSize: styleFont }} />, [styleFont]);
  const areaIcon = useMemo(() => <TravelExploreIcon sx={{ fontSize: styleFont }} />, [styleFont]);
  const handleAreasToggle = useCallback(() => {
    setShowAreas((prev) => !prev);
  }, [setShowAreas]);

  


  // console.log('nivel',nivelSeleccionado)

  return (
    <Box sx={{ overflowY: 'auto', height: '82vh', bgcolor: '#13131f' }}>
      {showOptions && (
        <Box display="flex" justifyContent="space-between" px={'0.5vw'} py={'0.5vw'}>
          <Button onClick={handleHome} sx={{ color: '#c3c3c3', fontSize: '0.7vw', }}>
            <AppsIcon sx={{ fontSize: styleFont,  marginRight:'0.5vw' }} /> {homeLabel}
          </Button>
          <Button onClick={handleExit} sx={{ color: '#c3c3c3', fontSize: '0.7vw', }}>
            <LogoutIcon sx={{ fontSize: styleFont,  marginRight:'0.5vw' }} /> {t('cerrar_sesion', 'Cerrar sesion')} 
          </Button>
        </Box>
      )}

      {/* Regions */}
      <Section
        label="regions"
        items={regions}
        open={true}
        onToggle={() => {}}
        collapsible={false}
        disabled={true}
        // disabled={!regions.length}
        itemIcon={publicIcon}
        onItemClick={handleRegionClick}
        selected={regionSeleccionada}
        translate={translate}
        capitalize={capitalize}
        sidebarOpen={true}
        fontSize={styleFont}
        handleNivel={handleNivel}
        region={false}
      />

      {/* Areas */}
      {regionSeleccionada && (
        <Section
          label="areas"
          items={areas}
          open={showAreas}
          onToggle={handleAreasToggle}
          disabled={!areas.length}
          itemIcon={areaIcon}
          onItemClick={handleAreaClick}
          selected={areaSeleccionada}
          region={regionSeleccionada}
          translate={translate}
          capitalize={capitalize}
          sidebarOpen={true}
          fontSize={styleFont}
          handleNivel={handleNivel}
        />
      )}

      {/* Centers */}
      {regionSeleccionada && areaSeleccionada && (
        <Box px={1} pt={1}>
          <Typography sx={{ color: 'white', fontSize: styleFont, mb: 0.5 }}>
            {t('centers', 'Centros')}
          </Typography>
          <Divider sx={{ bgcolor: '#2f2f2f', mb: 1 }} />
          <List disablePadding>
            {centers.map((center) => (
              <ListItemButton
                key={center}
                selected={isSameSelectionValue(centroSeleccionado, center)}
                onClick={() => {
                    handleCentroClick(center);
                    handleNivel('centro');
                  }
                }
                sx={{
                  height: '5vh',
                  width: '12vw',
                  pl: 2,
                  py: 1,
                  borderRadius:'0.4vw',
                  '&.Mui-selected': { backgroundColor: 'rgb(222, 78, 17)' },
                  '&:hover': { backgroundColor: 'rgb(255,120,60)' },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                  <BootstrapTooltip
                    title={`${t('center_label', 'Centro')}: ${labelCentro({ region: regionSeleccionada, area: areaSeleccionada, centro: center }, capitalize(center))}`}
                    arrow
                    TransitionComponent={Zoom}
                    enterDelay={300}
                  >
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log(`Accediste a este centro:`, center);
                        handleNivel('centro');
                        handleCentroClick(center);
                      }}
                      sx={{ color: 'white', bgcolor: '#303e54', borderRadius: '0.25vw', p: '0.25vw' }}
                      size="small"
                    >
                      <FmdGoodIcon sx={{ fontSize: styleFont }} />
                    </IconButton>
                  </BootstrapTooltip>
                </ListItemIcon>
                <ListItemText
                  primary={labelCentro({ region: regionSeleccionada, area: areaSeleccionada, centro: center }, capitalize(center))}
                  primaryTypographyProps={{ noWrap: true, sx: { fontSize: '1.2vh' } }}
                />
              </ListItemButton>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default memo(DrawerList);
